import { JobGroupBy } from '../../entities/job/job.group.by';
import { JobViewFilters } from '../../entities/job/job.filters';
import { JobViewType } from '../../entities/job/job.view.type';
import { PagingOptions } from '../../entities/shared/paging.options';
import { SortJobOptions } from '../../entities/job/job.sort.options';

export enum JobViewRequestReturnType {
    Refiners = 'Refiners',
    Count = 'Count'
}

export interface JobViewRequest {
    viewId: string;
    widgetId?: string;
    currentUserId?: string;
    refinements?: JobViewFilters;
    sort?: SortJobOptions;
    paging?: PagingOptions;
    groupBy?: JobGroupBy;
    viewType?: JobViewType;
    displayType?: string;
    returnWorkOrdersOnly?: boolean;
    returnOnly?: JobViewRequestReturnType;
    requireCount?: boolean;
}


